import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../_redux/school-reports/SchoolReportsAction";
import * as uiHelpers from "../SchoolReportStudentsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useSchoolReportStudentsUIContext } from "../SchoolReportStudentsUIContext";

export function SchoolReportStudentsTable() {
  // School Report Students UI Context
  const schoolReportStudentsUIContext = useSchoolReportStudentsUIContext();
  const schoolReportStudentsUIProps = useMemo(() => {
    return {
      ids: schoolReportStudentsUIContext.ids,
      setIds: schoolReportStudentsUIContext.setIds,
      queryParams: schoolReportStudentsUIContext.queryParams,
      setQueryParams: schoolReportStudentsUIContext.setQueryParams,
      term: schoolReportStudentsUIContext.term
    };
  }, [schoolReportStudentsUIContext]);

  // Getting curret state of School Report Students list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.schoolReports }),
    shallowEqual
  );
  const { studentTotalCount, studentEntities, studentIds, listLoading } = currentState;
  
  // School Report Students Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    schoolReportStudentsUIProps.setIds(studentIds);
    if (schoolReportStudentsUIProps.term) dispatch(actions.getStudents(schoolReportStudentsUIProps.queryParams));
    return () => dispatch(actions.cleanReportStudentsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentIds, schoolReportStudentsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret,
      style: {
        width: "200px",
      }
    },
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "surname",
      text: "Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "sexName",
      text: "Cinsiyeti",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "grade",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: studentTotalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: schoolReportStudentsUIProps.queryParams.pageSize,
    page: schoolReportStudentsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={studentEntities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                schoolReportStudentsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities: studentEntities,
                ids: schoolReportStudentsUIProps.ids,
                setIds: schoolReportStudentsUIProps.setIds
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={studentEntities} />
              <NoRecordsFoundMessage entities={studentEntities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}